export default __webpack_public_path__ + "static/media/ManjarabadFort.91fb346f.jpg";